<template>
  <div class="terms-agrees">
    <div class="item" v-for="(agreement, index) in agreements" :key="index">
      <v-row no-gutters class="agree">
        <v-col cols="9" class="d-flex align-center">
          <p class="mb-0">
            <span>{{ index + 1 }}. </span>
            {{ agreement.question }}
          </p>
        </v-col>
        <v-col cols="3" class="text-right">
          <button
            class="btn-agree"
            :class="{ active: agreement.isAgreed }"
            @click="agreement.isAgreed = !agreement.isAgreed"
          >
            {{ agreement.content }}
          </button>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      agreements: [
        {
          question: '약정서 및 약관을 확실히 수령하였습니까?',
          content: '수령함',
          isAgreed: false,
        },
        {
          question: '약정서 및 약관의 중요한 내용에 대하여 설명을 들었습니까?',
          content: '들었음',
          isAgreed: false,
        },
        {
          question: '중개수수료를 이용자로부터 받는 것이 불법이라는 설명을 들었습니까?',
          content: '들었음',
          isAgreed: false,
        },
      ],
    }
  },
  computed: {
    isAgreedAll() {
      return this.agreements.every((ag) => {
        return ag.isAgreed === true
      })
    },
  },
  watch: {
    isAgreedAll(v) {
      this.$emit('emitAgreedAll', v)
    },
  },
  methods: {
    agree(agreement) {
      agreement.isAgreed = !agreement.isAgreed
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

.terms-agrees {
  .item {
    display: flex;
    align-items: center;

    width: 100%;

    &:not(:last-child) {
      margin-bottom: 20px;
    }

    .agree button.btn-agree {
      width: 80% !important;
    }
  }
}
</style>
